import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  root: {
    backgroundColor: theme.palette.white,
    position: 'relative',
    padding: pxToRem(14),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: '1rem',
  },
  removeButton: {
    height: pxToRem(20),
    marginRight: pxToRem(20),
    marginLeft: pxToRem(20),
    fontWeight: 400,
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        position: 'absolute',
      },
      '&:hover': {
        background: 'transparent',
      },
      '&:focus': {
        background: 'transparent',
      },
      '&:active': {
        background: 'transparent',
      },
    },
  },
  toggleColumn: {
    paddingTop: '0.2rem',
  },
  detailRowIconColor: {
    color: theme.palette.neutralTertiary,
  },
  pill: {
    height: '1rem',
  },
  permissionList: {
    selectors: {
      '& .ms-DetailsList-contentWrapper': {
        height: 'auto',
        maxHeight: pxToRem(450),
        overflowY: 'auto',
        overflowX: 'hidden',
      },
    },
    paddingBottom: pxToRem(16),
  },
  headerContainer: {
    selectors: {
      '> span': {
        width: '100%',
      },
    },
  },
  createButton: {
    float: 'right',
  },
  permissionCell: {
    display: 'flex',
  },
  permissionBox: {
    width: pxToRem(160),
    selectors: {
      '& .ms-TextField-field': {
        fontSize: `${pxToRem(12)} !important`,
        fontWeight: 400,
      },
      '& .ms-TextField-fieldGroup': {
        background: theme.palette.neutralWhite,
        height: pxToRem(20),
      },
    },
  },
  errorMessage: {
    color: theme.palette.accentError,
    fontSize: '0.75rem',
    padding: `0 ${pxToRem(10)}`,
  },
  errorBox: {
    selectors: {
      '& .ms-TextField-fieldGroup': {
        borderColor: theme.palette.accentError,
      },
    },
  },
});
